<template>

    <div class="file-navigator">
        <div class="folder-section">
            <div class="root-item" >
                <span @click="folderStack = []" style="cursor: pointer; color: #4a90e2; font-weight: bold;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"
                        style="vertical-align: middle; margin-right: 4px; flex-shrink: 0; cursor: pointer;"
                        @click="folderStack = folderStack.slice(0, i + 1)">
                        <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                    </svg>
                    Top Folder
                </span>
                <template v-for="(folder, i) in folderStack" :key="i">
                <span style="color: #888;"> / </span>
                <span 
                    @click="folderStack = folderStack.slice(0, i + 1)"
                    style="cursor: pointer; color: #4a90e2;"
                >{{ folder.text }}</span>
                </template>
            </div>

        
            <!-- Tree 1: Folders only -->
            <BaseTree class="mtl-tree folder-list" v-model="currentFolders" ref="treeRef" treeLine>
                <template #default="{ node, stat }">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"
                    style="vertical-align: middle; margin-right: 4px; flex-shrink: 0; cursor: pointer;"
                    @click="onFolderClick(node, stat)">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
                </svg>
                <span class="mtl-ml folder-items" :title="node.text"
                    
                    @click="onFolderClick(node, stat)"
                >
                    {{ node.text }}
                </span>
                </template>
            </BaseTree>
        </div>
        <div class="file-section">
            <!-- Tree 2: Files only -->
            <BaseTree class="mtl-tree file-list" v-model="currentFiles" ref="tree2Ref" @check:node="onCheckNode('tree2', $event)" treeLine>
                <template #default="{ node, stat }">
                <input class="mtl-checkbox" style="width: 10px; height: 10px;" type="checkbox" v-model="stat.checked" />
                <svg v-if="node.text.toLowerCase().endsWith('.pdf')"
                    xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"
                    fill="none" stroke="#e05252" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"
                    style="vertical-align: middle; margin-right: 4px; flex-shrink: 0; cursor: pointer;"
                    @click="openFile(node, currentPath)">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="9" y1="13" x2="15" y2="13"/>
                    <line x1="9" y1="17" x2="15" y2="17"/>
                </svg>
                <span class="mtl-ml file-items" :title="node.text"
                    
                    @click="openFile(node, currentPath)"
                >
                    {{ node.text }}
                </span>
                </template>
            </BaseTree>
            <ul>
                <li class="mt-2" style="text-align: center;">
                    <span title="Download Selected">
                        <button 
                            :disabled="checkedFiles.length == 0 || isDownloadingSelected" 
                            @click="downloadSelected" 
                            class="btn btn-primary btn-sm px-2 btn2">
                                <span v-if="isDownloadingSelected" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                <i class="bi bi-download me-2"></i>
                                    Selected
                            </button>
                    </span>
                        <button 
                            title="Download All" 
                            :disabled="isDownloadingAll"
                            @click="downloadAll" 
                            class="btn btn-primary btn-sm px-2 btn2">
                                <span v-if="isDownloadingAll" class="spinner-border spinner-border-sm me-2" role="status"></span>
                                <i class="bi bi-download me-2"></i> 
                                All
                        </button>
                </li>
            </ul>
        </div>
    </div>    
</template>
<script setup>
    import {  ref, watchEffect, computed, watch, nextTick} from 'vue';
    import { BaseTree} from '@he-tree/vue'
    import '@he-tree/vue/style/default.css'
    import '@he-tree/vue/style/material-design.css'
    import { getTimestamp }from '@/composables/toolbox' 
    import projectData from '@/composables/fe_projectData';
    import { useStore } from 'vuex';
    
    const { getFiles, viewFile, zipFiles } = projectData()
    const props = defineProps(['clientId', 'projectId'])
    const emit = defineEmits(['loaded'])
    const openMainReport = (mainReport) => {
        openFile(mainReport, getParentFolder(mainReport))
    }
    defineExpose({openMainReport})

    const store = useStore();

    const selectedFolder = computed(() => 
        folderStack.value[folderStack.value.length - 1] ?? null
    )
    function onFolderClick(node, stat) {
        stat.open = false
        folderStack.value.push(node)
    }
    watchEffect(() => {
   
        

        // // console.log(route.path, route.params.projectId, "######")
        // if (route.path.includes("site")) {
        //     site.value = true
        // } else if (route.path.includes("customerhub")) {
        //     customerhub.value = true
        // } else {
        //     site.value = false
        //     customerhub.value = false
        // }
        console.log('PROPSSSSSSSSSSSSSSSSSS', props)
        if (props.projectId && props.clientId) {
            // projectId.value = route.params.projectId
            // clientId.value = route.params.clientId
            Promise.all([
                getFiles(props.clientId, props.projectId)
            ])
            .then(res => {
               let treeDataIn = res[0].filter(f => !f.text.startsWith("__") && !f.text.toLowerCase().endsWith(".db"))
                treeData.value = treeDataIn.filter(f => !f.text.startsWith("~~"))
                const mainReportRegex = new RegExp("Report\.[0-9]{4}\.[0-9]{2}\.[0-9]{2}\.R")
                let valueA = treeDataIn.filter(f => {
                    // console.log(f.text, mainReportRegex.test(f.text), "@@@")
                    
                    return mainReportRegex.test(f.text)
                })
                valueA.sort((a, b) => b.text.localeCompare(a.text));
                emit('loaded', (valueA && valueA.length>0)? valueA[0]:null)
                // mainReport.value = treeData.value.find(f => {
                //     // console.log(f.text, mainReportRegex.test(f.text), "@@@")
                //     return mainReportRegex.test(f.text)
                // })
            })
        }

        
    })

    const treeData = ref([]);
    const treeRef = ref(null)
    const tree2Ref = ref(null)
    const folderStack = ref([])

    const isDownloadingSelected = ref(false);
    const isDownloadingAll = ref(false);

    //const mainReport = ref("")

    const currentPath = computed(() => 
        folderStack.value.map(f => f.text).join('/')
    )

        const folderContents = computed(() => 
        selectedFolder.value ? selectedFolder.value.children : treeData.value
    )
    const closePdf = () => {
        store.commit('setPdfModal', { isOpen: false, url: '' });
    };
    const currentFolders = computed(() =>
        folderContents.value.filter(n => n.children && n.children.length > 0 
            && !n.text?.toLowerCase().startsWith('__') 
            && !n.text?.toLowerCase().endsWith('.db'))
    )

    const currentFiles = computed(() =>
        folderContents.value.filter(n => !n.children || n.children.length === 0)
    )

  
    watch(treeData, async () => {
        await nextTick()
        if (!treeRef.value) return

        treeRef.value.statsFlat.forEach(stat => {
            stat.open = false
            if (!stat.children || stat.children.length === 0) {
            if (stat.parent && stat.parent.data) return
            stat.checked = checkedPaths.value.has(stat.data.text)
            }
        })
    })

    watch(currentFolders, async () => {
        await nextTick()
        if (!treeRef.value) return
        treeRef.value.statsFlat.forEach(stat => {
            stat.open = false
        })
    })

    watch(currentFiles, async () => {
        await nextTick()
        if (!tree2Ref.value) return

        const prefix = getTree2Prefix()

        tree2Ref.value.statsFlat.forEach(stat => {
            stat.open = false
            if (!stat.children || stat.children.length === 0) {
            const path = prefix ? `${prefix}/${stat.data.text}` : stat.data.text
            stat.checked = checkedPaths.value.has(path)
            }
        })

        await nextTick()
    })

    const checkedFiles = ref([])
    const checkedPaths = ref(new Set())

    function buildPath(stat, prefix = '') {
        const parts = []
        let current = stat
        while (current) {
            parts.unshift(current.data.text)
            current = current.parent
        }
        const nodePath = parts.join('/')
        return prefix ? `${prefix}/${nodePath}` : nodePath
        }

        function getTree2Prefix() {
        return folderStack.value.map(f => f.text).join('/')
    }

    async function onCheckNode(tree = 'tree1', e) {
        await nextTick()
        if (e.checked) {
            if (tree === 'tree1' && treeRef.value) {
                treeRef.value.statsFlat
                .filter(stat => !stat.children?.length && !(stat.parent?.data))
                .forEach(stat => {
                    const path = stat.data.text
                    if (stat.checked) checkedPaths.value.add(path)
                    // else checkedPaths.value.delete(path)
                })
            }

            if (tree === 'tree2' && tree2Ref.value) {
                const prefix = getTree2Prefix()
                const visiblePaths = new Set(
                tree2Ref.value.statsFlat
                    .filter(stat => !stat.children?.length)
                    .map(stat => prefix ? `${prefix}/${stat.data.text}` : stat.data.text)
                )

                visiblePaths.forEach(path => {
                const stat = tree2Ref.value.statsFlat.find(
                    s => (prefix ? `${prefix}/${s.data.text}` : s.data.text) === path
                )
                if (stat?.checked) checkedPaths.value.add(path)
                else{
                    // checkedPaths.value.delete(path)
                    // console.log(path, "@@@@@")
                }
                })
            }
        } else {
            if (tree === 'tree2' && tree2Ref.value) {
                const prefix = getTree2Prefix()
                let removePath = prefix ? `${prefix}/${e.data.text}` : e.data.text
                console.log("here with", removePath, e)
                checkedPaths.value.delete(removePath)
            } else {
                let removePath = `${e.data.text}`
                console.log("here with", removePath, e)
                checkedPaths.value.delete(removePath)
            }
        }

        checkedFiles.value = [...checkedPaths.value]
        console.log(checkedFiles.value)
    }

    const downloadSelected = () => {
        isDownloadingSelected.value = true;
        console.log(checkedFiles.value)
        downloadFiles(checkedFiles.value)
        .finally(() => {
            isDownloadingSelected.value = false;
        })  
    }

    const downloadAll = () => {
        isDownloadingAll.value = true;
        const allFiles = []
        
        const collectFiles = (nodes, prefix = '') => {
            nodes.forEach(node => {
            if (!node.children || node.children.length === 0) {
                allFiles.push(prefix ? `${prefix}/${node.text}` : node.text)
            } else {
                collectFiles(node.children, prefix ? `${prefix}/${node.text}` : node.text)
            }
            })
        }
        
        collectFiles(treeData.value)
        downloadFiles(allFiles)
        .finally(() => {
            isDownloadingAll.value = false;
        })
    }

    // Downloads the files in a zip format
    const downloadFiles = (files) => {
        return zipFiles(props.clientId, props.projectId, files)
        .then(res => {
            console.log(res)
            const blobUrl = URL.createObjectURL(res);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = "files_"+getTimestamp()+".zip";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(blobUrl);
        }).catch(err => {
            console.error("Download failed:", err);
            // Handle error (maybe a toast notification)
        });
    }

//    const pdfOpen = ref(false)
//     const pdfUrl = ref('')

    const textFiles = ["txt", "csv"]
    const imageFiles = ["jpg", "png", "jpeg"]

    const openFile = (node, folder = null) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        console.log("isIOS2", isIOS, navigator.userAgent, navigator.platform, navigator.maxTouchPoints)
        if (node && node.text) {
            console.log("opening file", node.text, "with folder", folder, "@@@@@@@@@@@@@")
            const ending = node.text.toLowerCase().split(".").pop()


            if (ending.includes("pdf")) {
                openPdf(node, folder)
            } else if (textFiles.includes(ending)) {
                openTextFile(node, folder)
            } else if (imageFiles.includes(ending)) {
                openImageFile(node, folder)
            } else {
                alert("You clicked on a file type that a web browser cannot open. We ask that at the bottom left, you click the checkbox beside the file and download it, then use the appropriate program to view it.")
            }
        } else {
            if (!node) {
                alert("No file exists for this type. Please contact HydraSurvey and inform them of this for the file you clicked. Take a screen snap plese of what you did to get this message - thanks in advance for your time and assistance so we can get it resolved for you.")
            } else if (!node.text) {
                alert("This file has no name. Please contact HydraSurvey and inform them of this for the file you clicked. Take a screen snap plese of what you did to get this message - thanks in advance for your time and assistance so we can get it resolved for you.")
            } else {
                alert("Something went wrong when trying to open this file. Please contact HydraSurvey and inform them of this for the file you clicked. Take a screen snap plese of what you did to get this message - thanks in advance for your time and assistance so we can get it resolved for you.")
            }
        }
    }

    const openPdf = (node, folder = null) => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        console.log("isIOS", isIOS, navigator.userAgent, navigator.platform, navigator.maxTouchPoints)
        if (isIOS) {
            // --- iOS ONLY EXECUTION PATH ---
            const filename = node.text;
            
            // 1. Open blank tab IMMEDIATELY to bypass Safari popup blocker
            const newWindow = window.open('', '_blank');
            if (newWindow) {
                newWindow.document.write('<p style="font-family: sans-serif; padding: 20px;">Loading PDF...</p>');
            }

            viewFile(props.clientId, props.projectId, filename, folder)
                .then(response => {
                    const blob = new Blob([response], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blob);

                    // 2. Redirect the new tab to the Blob URL
                    if (newWindow) {
                        newWindow.location.href = blobUrl;
                    } else {
                        window.location.href = blobUrl;
                    }
                })
                .catch(err => {
                    console.error("Error loading PDF on iOS:", err);
                    if (newWindow) newWindow.close();
                });

            return; // Stop execution here for iOS
        }
        try {
            const filename = node.text;
            
            console.log(filename, folder,props.clientId, props.projectId, "@@@3")
            viewFile(props.clientId, props.projectId, filename, folder)
                .then(response => {
                    const blob = new Blob([response], { type: 'application/pdf' });
                    store.commit('setPdfModal', { isOpen: true, url: URL.createObjectURL(blob) });
                    // pdfUrl.value = URL.createObjectURL(blob);
                    // pdfOpen.value = true;
                })
                .catch(err => {
                    console.error("Error loading PDF:", err);
                });
        } catch (err) {
            console.error("Error in openPdf:", err);
        }
    }

    const openTextFile = (node, folder = null) => {
        try {
            const filename = node.text;
            
            viewFile(props.clientId, props.projectId, filename, folder)
                .then(response => {
                    console.log('here')
                    const blob = new Blob([response], { type: 'text/plain' });
                    store.commit('setPdfModal', { isOpen: true, url: URL.createObjectURL(blob) });
                    // pdfUrl.value = URL.createObjectURL(blob);
                    // pdfOpen.value = true;
                })
                .catch(err => {
                    console.error("Error loading text file:", err);
                });
        } catch (err) {
            console.error("Error in openTextFile:", err);
        }
    }
    
    const openImageFile = (node, folder = null) => {
        try {
            const filename = node.text;
            
            viewFile(props.clientId, props.projectId, filename, folder)
                .then(response => {
                    console.log('here')
                    const blob = new Blob([response], { type: 'image/jpeg' });
                    store.commit('setPdfModal', { isOpen: true, url: URL.createObjectURL(blob) });
                    // pdfUrl.value = URL.createObjectURL(blob);
                    // pdfOpen.value = true;
                })
                .catch(err => {
                    console.error("Error loading image file:", err);
                });
        } catch (err) {
            console.error("Error in openImageFile:", err);
        }
    }

    



    const getParentFolder = (node) => {
        // Find the parent folder name from treeData
        if (node && node.text) {
            for (let item of treeData.value) {
                if (item.children && item.children.some(child => child.text === node.text)) {
                    return item.text;
                }
            }
        }
        return null; // Loose file
    }



</script>
<style>

.folder-section {
    border-top: 3px solid hsl(6.05deg 67.23% 34.71%);
    padding-bottom:0px;
    border-bottom: 3px solid hsl(6.05deg 67.23% 34.71%);
}
.file-section {
    border-top: 3px solid hsl(6.05deg 67.23% 34.71%);
}
.mtl-tree.folder-list {
    width: 100%;
    padding-top:0px;
    padding-left:10px;

}
/* .mtl-tree.file-list {

    border-bottom: 3px solid hsl(6.05deg 67.23% 34.71%);
} */
.root-item {

    padding-top:4px;
    padding-left: 10px;
    font-size: 11px; 
    display: flex; 
    align-items: center; 
    gap: 4px; 
    flex-wrap: wrap;
}
.folder-items {
    padding-top:3px;
    padding-left:0px;
    cursor: pointer;
    white-space: nowrap; overflow: hidden;
    text-overflow: ellipsis; max-width: 199px;
    display: inline-block; vertical-align: middle;
    font-size:small;
}

.file-items {
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80%;
    display: 'inline-block'; 
    vertical-align: 'middle';
    font-size:small;
}


.file-navigator {
    /* The "Ram" logic: push away from top menus */
    margin-top: auto; 
    
    display: flex;
    flex-direction: column;
    
    /* Define the total height for the navigator area (e.g., 50% of the sidebar) */
    height: 50%; 
    min-height: 50%;
    width: 100%;
}

.folder-section, .file-section {
    /* Each takes 50% of the navigator's height (which is 25% total) */
    flex: 1; 
    min-height: 0; /* Critical for enabling inner scrolling */
    overflow-y: auto;
    padding: 0px 0;
}

/* Optional: Add a separator between the two trees */
.folder-section {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.vtlist {
    /* Set a max height so it doesn't push the buttons off the screen */
    max-height: calc(21vh - 41px); 
    
    /* Or use a calculated height if it's in a sidebar */
     height: calc(25vh - 41px); 

    /* The magic line: vertical scroll only when needed */
    overflow-y: auto !important; 
    
    /* Prevents horizontal scrollbars from popping up due to long filenames */
    overflow-x: hidden !important; 

    /* Standardizes look on some browsers */
    border: 1px solid #eee;
    padding: 5px;
}
</style>